import createReducer from "./createReducer";
import { addFiltering } from "./common/Filtering";
import { addColumnFilters } from "./common/ColumnFilters";
import { SUPPRESS_SUCCESS_GROWL } from "utils/constants";

const AFTER_EFFECTS_PROJECT_ACTIONS = {
	GET_AE_PROJECTS_AJAX: "GET_AE_PROJECTS_AJAX",
	GET_AE_PROJECTS_SUCCESS: "GET_AE_PROJECTS_SUCCESS",
	GET_AE_PROJECTS_ERROR: "GET_AE_PROJECTS_ERROR",
	CLEAR_AE_ERRORS: "CLEAR_AE_ERRORS",
	CLEAR_AE_PACKAGES: "CLEAR_AE_PACKAGES",
};

const initialState = {
	items: [],
	totalPages: 1,
	totalItems: 0,
	error: null,
	isLoading: false,
	isLoaded: false,
	isSaving: false,
	selectedPackage: null,
};

export function getAEPackages(libraryId) {
	return (dispatch, getState) => {
		let state = getState();
		let { filterInfo } = state.aePackages || {};
		if(filterInfo) {
			filterInfo.rpp = -1;
		}
		return dispatch({
			type: AFTER_EFFECTS_PROJECT_ACTIONS.GET_AE_PROJECTS_AJAX,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				url: `ui/creative-libraries/${libraryId}/assets`,
				params: {
					...filterInfo,
					advancedFilter: `all(in(assetType,AfterEffects))`,
				},
				success: AFTER_EFFECTS_PROJECT_ACTIONS.GET_AE_PROJECTS_SUCCESS,
				error: AFTER_EFFECTS_PROJECT_ACTIONS.GET_AE_PROJECTS_ERROR,
			},
		});
	};
}


export function clearAEErrors() {
	return (dispatch) => {
		return dispatch({
			type: AFTER_EFFECTS_PROJECT_ACTIONS.CLEAR_AE_ERRORS,
		});
	};
}

export function clearAEPackages() {
	return (dispatch) => {
		return dispatch({
			type: AFTER_EFFECTS_PROJECT_ACTIONS.CLEAR_AE_PACKAGES,
		});
	};
}

export const handlers = {
	[AFTER_EFFECTS_PROJECT_ACTIONS.GET_AE_PROJECTS_AJAX] :getAEPackagesRequest,
	[AFTER_EFFECTS_PROJECT_ACTIONS.GET_AE_PROJECTS_SUCCESS] :getAEPackagesSuccess,
	[AFTER_EFFECTS_PROJECT_ACTIONS.GET_AE_PROJECTS_ERROR] :getAEPackagesError,
	[AFTER_EFFECTS_PROJECT_ACTIONS.CLEAR_AE_ERRORS] :clearErrors,
	[AFTER_EFFECTS_PROJECT_ACTIONS.CLEAR_AE_PACKAGES] :resetAEPackages,
};

function getAEPackagesRequest(state, action) {
	return {
		...state,
		isLoading: true,
	};
}

function getAEPackagesSuccess(state, action) {
	return {
		...state,
		items: action.payload?.data?.items || [],
		totalItems: action.payload?.data?.totalItems || 0,
		totalPages: action.payload?.data?.totalPages || 1,
		isLoading: false,
		isLoaded: true,
	};
}

function getAEPackagesError(state, action) {
	let { errorObj } = action.payload;
	if(typeof errorObj !== 'object'){
		errorObj = {
			description: action.payload.error?.message,
			code: action.payload.error?.response?.status,
		};
	}
	return {
		...state,
		isLoading: false,
		error: errorObj,
	};
}

function clearErrors(state, action) {
	return {
		...state,
		error: null,
	};
}

function resetAEPackages() {
	return { ...initialState };
}

let reducerConfig = {
	typeRoot: "AFTER_EFFECTS_PROJECTS",
	actionTypes: AFTER_EFFECTS_PROJECT_ACTIONS,
	actionCreators: {
		getAEProjects: getAEPackages,
		clearAEErrors,
	},
	initialState,
	handlers,
};

reducerConfig = addFiltering(reducerConfig, {});
reducerConfig = addColumnFilters(reducerConfig, {});

export default createReducer(reducerConfig.initialState, reducerConfig.handlers);
export const AfterEffectsPackages = reducerConfig.actionCreators;
